import { SystemContentApi } from '@shared/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@shared/types/http';

interface SystemContent {
    id?: number,
    type: string,
    content: string,
    createdAt?: string,
    updatedAt?: string
}

export default class SettingSystemStore extends BaseStore {
    systemContent: SystemContent | null = null;
    api: SystemContentApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            systemContent: observable,
            getSystemContentByType: flow.bound
        });
        this.api = new SystemContentApi();
    }

    *getSystemContentByType(type: string) {
        try {
            const res: ResponseData<SystemContent> = yield this.rootStore.apiStore.call(this.api, this.api.getSystemContentByType, type);
            if (res.ok) {
                this.systemContent = res.data;
            }
        } catch (error) {
            console.error(error);
        }
    }

    clean(): void {
        super.clean();
        this.systemContent = null;
    }
}
